import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export const ProtectedRoute = ({ children, role = "admin" }) => {
  const { user, checked } = useAuth();
  if (!checked) return <div className="p-12 text-center font-mono text-sm">Vérification...</div>;
  if (role === "tenant") {
    if (!user) return <Navigate to="/locataire/login" replace />;
    if (user.role !== "tenant") return <Navigate to="/" replace />;
    return children;
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  // Tenants must NOT access admin pages
  if (user.role === "tenant") return <Navigate to="/locataire" replace />;
  return children;
};
